import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '@/pages/home/home.css';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page not found — FOLD. Artisan Bakery';
  }, []);

  return (
    <main className="min-h-screen bg-[#F5F1EB] text-[#171515] flex items-center">
      <div className="fold-shell w-full py-24">
        <p className="fold-label text-[#8A8580]">Error 404</p>
        <h1 className="mt-5 fold-serif uppercase leading-[0.92] tracking-[-0.03em] text-[13vw] sm:text-[9vw] lg:text-[6rem]">
          Nothing on <span className="italic">this shelf.</span>
        </h1>
        <p className="mt-6 max-w-[420px] text-[15px] leading-[1.75] text-[#45403c]">
          The page you were looking for has moved or never existed. The bakes are still here.
        </p>
        <nav className="mt-10 flex flex-wrap gap-x-8 gap-y-3" aria-label="Recovery links">
          <Link to="/" className="fold-label fold-link whitespace-nowrap cursor-pointer">Back to home</Link>
          <Link to="/collection" className="fold-label fold-link whitespace-nowrap cursor-pointer">See the collection</Link>
        </nav>
      </div>
    </main>
  );
}